import { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';

import { CustomInputInteface } from '../../core/models/inputs';
import { Icon } from '../Icon/Icon';

interface Props {
  id: string;
  link?: {
    text: string;
    href: string;
  };
  type?: string;
  name: string;
  info?: string;
  label?: string;
  icon?: JSX.Element;
  placeholder: string;
  emptyMessage?: string;
  autoComplete?: string;
  invalidMessage?: string;
  input: CustomInputInteface;
  readOnly?: boolean;
  rows?: number;
}

function CustomInput({
  id,
  link,
  type,
  name,
  info,
  label,
  icon,
  placeholder,
  emptyMessage,
  autoComplete,
  invalidMessage,
  input,
  readOnly,
  rows,
}: Props) {
  const [currentType, setCurrentType] = useState(type || 'text');
  const error = useMemo(
    () => (!input.showError ? '' : input.isEmpty ? 'empty' : !input.isValid ? 'invalid' : ''),
    [input.showError, input.isEmpty, input.isValid],
  );

  return (
    <div className={`input${!error ? '' : ' error'}${!icon ? '' : ' with-icon'}`}>
      <div className="input__header">
        {!label ? null : (
          <label className="input__label" htmlFor={id}>
            {label}
          </label>
        )}
        {!link ? null : (
          <Link className="input__link" to={link.href}>
            {link.text}
          </Link>
        )}
      </div>
      <div className="input__wrapper">
        {type === 'textarea' ? (
          <textarea
            className="input__field"
            id={id}
            autoComplete={autoComplete || 'off'}
            name={name}
            rows={rows || 5}
            value={input.value}
            onChange={input.onChange}
            placeholder={placeholder}
            readOnly={readOnly}
          />
        ) : (
          <input
            className={`input__field${type === 'password' ? ' input__field--password' : ''}`}
            id={id}
            autoComplete={autoComplete || 'off'}
            type={currentType}
            name={name}
            value={input.value}
            onChange={input.onChange}
            placeholder={placeholder}
            readOnly={readOnly}
          />
        )}
        {type !== 'password' ? null : (
          <button
            className="input__btn"
            type="button"
            onClick={() => setCurrentType(currentType === 'password' ? 'text' : 'password')}
          >
            <span className="sr-only">Change input type</span>
            {currentType === 'password' ? (
              <Icon.Eye className="icon-small" />
            ) : (
              <Icon.Eyehidden className="icon-small" />
            )}
          </button>
        )}
        {!icon ? null : <span className="input__icon">{icon}</span>}
        {!info ? null : <div className="input__info caption">{info}</div>}
      </div>
      {!error ? null : (
        <div className="input__error">
          <span>
            {error === 'empty' ? emptyMessage : error === 'invalid' ? invalidMessage : ''}
          </span>
        </div>
      )}
    </div>
  );
}

export default CustomInput;
